import { differenceInMinutes, isValid, parseISO } from 'date-fns';

export function minutesBetween(from: string | null, to: string | null): number | null {
  if (!from || !to) return null;
  const start = parseISO(from);
  const end = parseISO(to);
  if (!isValid(start) || !isValid(end)) return null;
  return differenceInMinutes(end, start);
}
